import React, { useState } from "react";
import BrandIcon from "./BrandIcon";

const PHONE_REGEX = /^01[016789]-?\d{3,4}-?\d{4}$/;

export default function LeadForm({ question, answer, tags, category, queryLogId, onSubmit, isSubmitting }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "이름을 입력해주세요.";
    if (!phone.trim()) {
      newErrors.phone = "전화번호를 입력해주세요.";
    } else if (!PHONE_REGEX.test(phone.trim())) {
      newErrors.phone = "올바른 전화번호 형식이 아닙니다. (예: 010-1234-5678)";
    }
    if (!consent) newErrors.consent = "마케팅 수신 동의가 필요합니다.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await onSubmit({
        name: name.trim(),
        phone: phone.trim(),
        email: email.trim(),
        question,
        answer,
        tags,
        category,
        query_log_id: queryLogId,
        consent_marketing: consent,
      });
      setSubmitted(true);
    } catch {
      setErrors({ form: "전송 중 오류가 발생했습니다. 다시 시도해주세요." });
    }
  };

  if (submitted) {
    return (
      <div className="w-full p-6 bg-[#eef5e8] rounded-2xl border border-[#c7d8b9] text-center">
        <div className="mx-auto mb-3 h-11 w-11 rounded-2xl bg-[#58664a] text-white flex items-center justify-center">
          <BrandIcon name="check" size={22} />
        </div>
        <p className="text-[#52683f] font-semibold text-lg">신청이 완료되었습니다.</p>
        <p className="text-[#52683f] mt-2 text-sm">
          입력하신 연락처로 상세 리포트를 보내드리겠습니다.
        </p>
      </div>
    );
  }

  return (
    <div className="w-full p-6 bg-white/70 rounded-2xl border border-[#e2d6c8]">
      <h3 className="text-lg font-bold text-[#1f2933] mb-1">
        더 상세한 리포트를 메일로 보내드릴까요?
      </h3>
      <p className="text-sm text-[#6f6258] mb-5 leading-relaxed">
        전문 법률/세무사가 작성한 맞춤 리포트를 무료로 받아보세요.
      </p>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* 이름 */}
        <div>
          <input
            type="text"
            placeholder="이름"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={`w-full px-4 py-3 rounded-xl border bg-white/85 ${
              errors.name ? "border-[#d35f4f]" : "border-[#d7c7b5]"
            } focus:outline-none focus:border-[#9b6f45]`}
          />
          {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
        </div>

        {/* 전화번호 */}
        <div>
          <input
            type="tel"
            placeholder="전화번호 (010-1234-5678)"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className={`w-full px-4 py-3 rounded-xl border bg-white/85 ${
              errors.phone ? "border-[#d35f4f]" : "border-[#d7c7b5]"
            } focus:outline-none focus:border-[#9b6f45]`}
          />
          {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
        </div>

        {/* 이메일 */}
        <div>
          <input
            type="email"
            placeholder="이메일 (선택)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 rounded-xl border border-[#d7c7b5] bg-white/85 focus:outline-none focus:border-[#9b6f45]"
          />
        </div>

        {/* 마케팅 동의 */}
        <div className="flex items-start gap-2">
          <input
            type="checkbox"
            id="consent"
            checked={consent}
            onChange={(e) => setConsent(e.target.checked)}
            className="mt-1 w-4 h-4 text-[#1f2933] rounded"
          />
          <label htmlFor="consent" className="text-sm text-[#5f554b] leading-tight">
            [필수] 마케팅 정보 수신 및 개인정보 수집에 동의합니다.
            <br />
            <span className="text-xs text-[#8a7968]">
              수집 항목: 이름, 연락처, 이메일 | 목적: 상담 리포트 발송 | 보유기간: 1년
            </span>
          </label>
        </div>
        {errors.consent && <p className="text-red-500 text-xs">{errors.consent}</p>}

        {/* 전송 오류 */}
        {errors.form && (
          <p className="text-red-500 text-sm text-center">{errors.form}</p>
        )}

        {/* 제출 버튼 */}
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-3 bg-[#1f2933] text-[#f6f1e8] rounded-xl font-semibold hover:bg-[#34414d] disabled:bg-[#c6b8a8] disabled:cursor-not-allowed transition-colors inline-flex items-center justify-center gap-2"
        >
          {isSubmitting ? "전송 중..." : <><BrandIcon name="send" size={17} /> 무료 리포트 신청하기</>}
        </button>
      </form>
    </div>
  );
}
